import type { LeftMenuType } from 'redux/reducers/leftSideMenu'

import clsx from 'clsx'
import { useGetProps } from 'features/messaging/hooks/useFilters'

import TrialNotification from '../trialNotification'
import { useMenuHandlers } from './hooks/useMenuHandlers'
import css from './LeftSideMenu.module.scss'
import { AccountMenu, CampaignMenu, ContactsMenu, MessagingMenu, TeamMenu } from './types'
import './style.scss'

const linkBuilder = (type: LeftMenuType, id: string, archived = false) => {
	const link = archived ? '/archive' : '/campaigns'
	switch (type) {
		case 'campaign':
		case 'team':
			return `${link}/${id}`
		case 'contacts':
			return `/campaigns/${id}/contacts`
		default:
			return ''
	}
}

interface LeftSideMenuProps {
	className?: string
}

export function LeftSideMenu({ className }: LeftSideMenuProps) {
	const { active, bottomListActiveHandler, clickOnLink, leftSide } = useMenuHandlers()
	const { filter, mailboxFilter, searchDraft } = useGetProps() || {
		filter: '' as const,
		mailboxFilter: '' as const,
		searchDraft: ''
	}

	const renderMenuContent = () => {
		const isOnlyOne = leftSide.type === 'account'

		if (isOnlyOne) {
			return <AccountMenu leftSide={leftSide} />
		}

		switch (leftSide.type) {
			case 'campaign':
				return (
					<CampaignMenu
						active={active}
						bottomListActiveHandler={bottomListActiveHandler}
						clickOnLink={clickOnLink}
						leftSide={leftSide}
						linkBuilder={linkBuilder}
					/>
				)

			case 'contacts':
				return (
					<ContactsMenu
						active={active}
						leftSide={leftSide}
					/>
				)

			case 'messaging':
				return (
					<MessagingMenu
						filter={filter}
						leftSide={leftSide}
						mailboxFilter={mailboxFilter}
						searchDraft={searchDraft || ''}
					/>
				)

			case 'team':
				return (
					<TeamMenu
						active={active}
						bottomListActiveHandler={bottomListActiveHandler}
						clickOnLink={clickOnLink}
						leftSide={leftSide}
						linkBuilder={linkBuilder}
					/>
				)

			default:
				return null
		}
	}

	return (
		<div className={clsx(className, css.root, 'left-menu')}>
			<div className={clsx(css.list, 'app-scroll')}>
				{renderMenuContent()}
			</div>
			<TrialNotification />
		</div>
	)
}
